// import event from './event/index';
const __DEV__ = import.meta.env.VITE_ENV != 'production';
let loadId = __DEV__
  ? 'b415f535ae80432ebccdabaaee072963'
  : 'b87a442d3ae544ceae42830d7b3169aa';
(function() {
  if (window.zhuge) return;
  window.zhuge = [];
  window.zhuge.methods = '_init identify track trackRevenue getDid getSid getKey setSuperProperty setUserProperties setWxProperties setPlatform'.split(
    ' '
  );
  window.zhuge.factory = function(b) {
    return function() {
      let a = Array.prototype.slice.call(arguments);
      a.unshift(b);
      window.zhuge.push(a);
      return window.zhuge;
    };
  };
  for (let i = 0; i < window.zhuge.methods.length; i++) {
    let key = window.zhuge.methods[i];
    window.zhuge[key] = window.zhuge.factory(key);
  }
  window.zhuge.load = function(b, x) {
    if (!document.getElementById('zhuge-js')) {
      let a = document.createElement('script');
      let verDate = new Date();
      let verStr =
        verDate.getFullYear().toString() +
        verDate.getMonth().toString() +
        verDate.getDate().toString();
      a.type = 'text/javascript';
      a.id = 'zhuge-js';
      a.async = !0;
      a.src = 'https://sjsc.ennew.com/zhuge.js?v=' + verStr;
      a.onerror = function() {
        window.zhuge.identify = window.zhuge.track = function(
          ename,
          props,
          callback
        ) {
          if (
            callback &&
            Object.prototype.toString.call(callback) === '[object Function]'
          ) {
            callback();
          } else if (
            Object.prototype.toString.call(props) === '[object Function]'
          ) {
            props();
          }
        };
      };
      let c = document.getElementsByTagName('script')[0];
      c.parentNode.insertBefore(a, c);
      window.zhuge._init(b, x);
    }
  };
  window.zhuge.load(loadId, {
    // 配置应用的AppKey
    superProperty: {
      // 全局的事件属性
      JS环境: 'H5', // 取值范围 小程序 or H5 or PC,
      产品名称: '电子工牌' // 当前产品名称
    },
    debug: __DEV__, // 测试，开发环境开启，正式环境需关闭
    autoTrack: true, // 启用全埋点采集
    duration: false, // 开启自动采集页面停留时长
    singlePage: true // 是否是单页面应用（SPA），启用autoTrack后生效
  });
})();

// 把event里面的事件都放在window对象下
// Object.entries(event).forEach(([key, item]) => {
//   window[key] = item;
// });
